import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { StatusCard } from 'components';
import { manageStatusCircle } from 'components/screens/constants';
import { EmptyStateDashboard } from './emptyStateDashboard';
import { DashboardWidgetShell, DashboardWidgetSkeleton } from './widgets';
import { dashboardActions } from 'store';
import { FindLoad } from 'utils';

const ACTION_TYPE = 'GET_DASHBOARD_CLIENTS_OVERVIEW';

export const ClientsOverview = ({ item, handleDeleteWidget }) => {
    const { clientsOverview } = useSelector((state) => ({
        clientsOverview: state.dashboard.clientsOverview,
    }));
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const newThisMonth = clientsOverview?.newThisMonth;
    const statusCounts = _.omit(clientsOverview || {}, ['newThisMonth']);
    const total = _.sum(_.values(statusCounts));

    useEffect(() => {
        if (item?.apiPath) {
            dispatch(dashboardActions.getWidgetsData(ACTION_TYPE, item?.apiPath));
        }
    }, [item?.apiPath]);

    if (loader?.length) {
        return <DashboardWidgetSkeleton />;
    }

    return (
        <DashboardWidgetShell iconId={2} onClose={handleDeleteWidget}>
            <div className="main-dashboard-client-overview-card-wrapper">
                {clientsOverview ? (
                    <>
                        <h1 className="client-overview-card-total">{total}</h1>

                        <div className="client-overview-meta">
                            <span className="client-overview-total-label">Total clients</span>
                            {typeof newThisMonth === 'number' && (
                                <span className="client-overview-delta">+{newThisMonth} this month</span>
                            )}
                        </div>

                        {total > 0 && (
                            <div className="client-overview-bar">
                                {_.map(statusCounts, (value, status) =>
                                    value ? (
                                        <span
                                            key={status}
                                            className="client-overview-bar__segment"
                                            style={{ flexGrow: value, background: manageStatusCircle(status).circleColor }}
                                        />
                                    ) : null
                                )}
                            </div>
                        )}

                        <div className="main-dashboard-client-overview-statuses">
                            {_.map(statusCounts, (value, status) => (
                                <StatusCard key={status} status={status} text={` (${value})`} />
                            ))}
                        </div>
                    </>
                ) : (
                    <EmptyStateDashboard iconId={2} title="No clients yet" description={'Add your first client to start tracking their progress.'} />
                )}
            </div>
        </DashboardWidgetShell>
    );
};
